export default "__VITE_ASSET__DBy5VOO3__"